import dragTree from "@/view/dispatch_test/drag_tree/drag_test";
import data from "@/view/dispatch_test/index/index_js/data";
import icon from "@/view/dispatch_test/mapIcon";
import bottomBox from "@/view/dispatch_test/bottom/bottomBox";
// import store from "@/store";
import { getMapData ,delayTaskApi} from "@/api/dispatch";
import EventBus from "@/ws/eventBus";
import store from "@/store/index";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default {
  name: "Dispatch",
  components: {
    dragTree,
    bottomBox,
  },
  data() {
   let self = this
    return {
      ...data,
      markers: [],
      selectedMarkers: [],
      mapDriverList:[],
      map_marker:[],
      complete_map_marker:[],
      taskMap:{},
      clusterRenderer:{
        render: ({ count, position ,markers}) =>{
          markers.forEach(item=>{
            item.status_x = item.get('status') === 3 ? item.get('success')  === 1 ? 3 : 4 : item.status;
          })
          let curous_icon = ''
          markers.sort((a,b)=>{
            let order = [4,3,2,1,0]
            return order.indexOf(a.status_x) - order.indexOf(b.status_x)
          })
          let icpn = {
            status:markers[0].get('status'),
            success:markers[0].get('success'),
            mean:markers[0].get('mean'),
            is_pickup:markers[0].get('is_pickup')
          }
            curous_icon = self.getChangeIcons(icpn)
          return  new google.maps.Marker({
            label: { text: count.toString(), color: "white", fontSize: "14px" },
            position,
            icon: {
              url: curous_icon,
              scaledSize: new google.maps.Size(24, 24),
            },
            // 设置zIndex
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          })
        }
      },

      timer:'',
      infoWindowWidth:0
    };
  },

  mounted() {
    this.updateMapData();
    store.commit("restartDrawLine");
    // console.log('-挂载。。')
    setTimeout(() => {
      delayTaskApi().then(res=>{})
    }, 3000);
    // 每隔4秒处理一次司机定位消息
      this.timer = setInterval(this.sendDriverUpdate, 4000);
  },
  watch:{
    map_driver_list:{
      handler(newValue, oldValue) {
        this.mapDriverList = [...newValue]
      },
      deep: true,
      // immediate: true
    }
  },
  computed: {
    map_task_list() {
      return store.state.dis_map_point_data.map_task_list;
    },
    map_hub_list() {
      let arr = []
      let hub_list = store.state.dis_map_point_data?.map_hub_list
      hub_list?.forEach((v,i)=>{
        arr.push({
          latitude:Number(v.latitude),
          longitude:Number(v.longitude)
        })
      })
// 计算所有点的边界框
      let minLat = arr[0]?.latitude;
      let maxLat = arr[0]?.latitude;
      let minLng = arr[0]?.longitude;
      let maxLng = arr[0]?.longitude;

      arr.forEach(point => {
        minLat = Math.min(minLat, point.latitude);
        maxLat = Math.max(maxLat, point.latitude);
        minLng = Math.min(minLng, point.longitude);
        maxLng = Math.max(maxLng, point.longitude);
      });

// 计算边界框的中心点
      const centerLat = (minLat + maxLat) / 2;
      const centerLng = (minLng + maxLng) / 2;
      this.centers = {
        lat:centerLat,
        lng:centerLng
      }

// 计算边界框的尺寸
      const latSpan = maxLat - minLat;
      const lngSpan = maxLng - minLng;

        // 将经纬度范围转换为像素范围
        const GLOBE_WIDTH = 256; // 世界地图的宽度（像素）
      if (arr.length > 2){
        this.initializedZooms = Math.round(Math.log(512 / Math.max(latSpan, lngSpan)) / Math.LN2);
      }else {
       this.initializedZooms = 15
      }

      return store.state.dis_map_point_data.map_hub_list;
    },
    map_driver_list() {
      let lsit = store.state.dis_map_point_data.map_driver_list;
      return lsit
    },
    teamList() {
      return store.state.dis_team_list;
    },
    map_draw_line_arr:{
      get(){
        let arr = store.state.task_draw_line_arr;
        if (!this.map_task_list) return;
        this.map_task_list.forEach((task) => {
          const delete_map = arr.findIndex((data) => {
            return (
              Number(task.latitude) === data.lat &&
              Number(task.longitude) === data.lng
            );
          });
          if (delete_map > -1) {
            task.open_index = true;
            task.index = delete_map;
          } else {
            task.open_index = false;
            task.index = null;
          }
        });
        return store.state.task_draw_line_arr;
      },
      set(){

      }
    },
  },
  created() {
  },
  methods: {
    onClusterClick(event, cluster, map) {
        this.selectedMarkers = []; // 存储选中的标记对象
        cluster.markers.forEach((item, index, arr) => {
          // console.log('999999999,,,,',item)
          item.status_x = item.get('status') === 3 ? item.get('success')  === 1 ? 3 : 4 : item.status;
          this.selectedMarkers.push({
            address:item.get('title'),
            invoice_number:item.get('invoice_number'),
            abs:item.get('abs'),
            status:item.status_x,
            mean:item.get('mean'),
            is_pickup:item.get('is_pickup'),
            success:item.get('success'),
            parent_store:item.get('parent_store'),
            parent_driver:item.get('parent_driver'),
            task_id:item.get('task_id')
          })
        });
        this.sidebarPosition = event.latLng;
        this.showRightSidebar = true;
        setTimeout(() => {
          var infoWindowContent = document.getElementById("cluster_info");
          this.cluster_infoWindowWidth =
            infoWindowContent?.offsetWidth / 2 + 20;
          this.cluster_infoWindowHight = infoWindowContent?.offsetHeight + 30;
        });
      },
    sendDriverUpdate(){
      if (store.state.driverLocationQueue?.length >0){
        store.commit('processNextDriverLocationUpdate')
      }
    },
    addMapLinster(){
      this.map.addListener("click", () => {
        // console.log('--click map--')
        this.closeAllFun();
        store.commit("restartDrawLine");
        this.$forceUpdate();
      });
    },
    //底部设置 设置tree 在右侧的展示
    btomSetHandle(e) {
      this.$refs.cus_tree.$refs.tree_data.settingHandle(e);
    },
    //底部设置司机
    btomSetDriverHandle(e) {
      if(this.map_driver_list){
        this.map_driver_list.forEach((driver) => {
          if (driver.is_online == 1 && driver.is_transfer == 0) {
            driver.map_status = 1;
          } else if (driver.is_online == 1 && driver.is_transfer == 1) {
            driver.map_status = 2;
          }
          let flage = e.findIndex((v) => v == driver.map_status);
          if (flage > -1) {
            driver.show_map = true;
          } else {
            driver.show_map = false;
          }
        });
      }
      this.$forceUpdate();
    },
    //点击地图上的marker点
    clickGmapMarker(task,index){
      // console.log('--click marker--',index,task)

      this.closeAllFunForTask(task)
      this.map_task_list[index].open = true
      this.map_task_list[index].mean = 'highlight'


      if (task.status == 1 || task.status == 2) {
        this.$refs.cus_tree.$refs.tree_data.chooseTreeData(index, task);
      }
      if (task.status == 0){
        this.$refs.cus_tree.$refs.unassigned_task.hightUnassignedList(task)
      }
      // 传入当前点击任务，高亮所属司机名下所有任务
      this.drawLineFromDriver(task)

      setTimeout(() => {
         var infoWindowContent = document.getElementById("infoWindowContent");
         this.infoWindowWidth = infoWindowContent.offsetWidth / 2 + 20;
       });

    },

    drawLineFromDriver(task){
      // console.log('--marker 连线--',task)

      store.commit("restartDrawLine");
      let index = this.map_task_list.findIndex(v=>v.task_id == task.task_id)
      // console.log('----indexindex---',index)

      if  (index >-1){
        let tasks = this.map_task_list[index]
        let parent_store_arr = []
        if (tasks.status == 1 || tasks.status == 2){
          if (typeof tasks.parent_store === 'string') {
            parent_store_arr = tasks.parent_store.split('#').filter(p => p !== '' && p !== 'undefined').map(Number);
          } else if (Array.isArray(tasks.parent_store)) {
            parent_store_arr = tasks.parent_store;
          }
          // console.log('parent_store_arr',parent_store_arr)

          let store_index = this.teamList.findIndex(a=>a.id == parent_store_arr[0])
          let driver_index = this.teamList[store_index].childen_data.findIndex(b=>b.worker_id == tasks.parent_driver)
          let driver =this.teamList[store_index].childen_data[driver_index]
          this.map_draw_line_arr = []
          if  (driver.is_online == 1){
            this.map_draw_line_arr.push({
              type:'driver',
              latitude:driver.latitude,
              longitude:driver.longitude,
              name:driver.name,
              worker_id:driver.worker_id,
            })
          }
          driver.childen_data.forEach(v=>{
            if (v.status == 1 || v.status == 2){
              this.map_draw_line_arr.push(v)
            }
          })
          // console.log(' this.map_draw_line_arr', this.map_draw_line_arr)
          store.commit('changeTaskLineArr',this.map_draw_line_arr)
        }

      }
    },
    clusterFindTaskHandle(i, v) {
      // console.log('--click 聚合点中item--',i,v)

      if (i.status == 1 || i.status == 2) {
        this.$refs.cus_tree.$refs.tree_data.chooseTreeData(v, i);
      }
      if (i.status == 0){
        this.$refs.cus_tree.$refs.unassigned_task.hightUnassignedList(i)
      }

      this.drawLineFromDriver(i)
    },
    //获取初始 未分配、树的数据
    updateMapData() {
      getMapData().then((res) => {
        if (res.code == 200) {
          store.commit("saveAllMapData", res.data);
          store.commit(
            "saveUnassignedList",
            res.data.unassigned_task_list
          );
          store.commit("saveTeamList", res.data.team_list);

          //解决初次进来，地图上没有pin点的问题  原因是：onGoogleApiLoaded方法中获取 state中的数据没有值，此时数据还在请求
          setTimeout(() => {
            this.$refs.dispatch_gmap.$mapPromise.then((map) => {
              this.map = map;
              // this.onGoogleApiLoaded();
              this.addMapLinster()
            });
          }, 200);
        }
      });
    },
    zoomIn() {
      this.map.setZoom(this.map.getZoom() + 1);
    },
    zoomOut() {
      this.map.setZoom(this.map.getZoom() - 1);
    },
    fullScreen() {
      let div = this.map.getDiv().firstChild;
      this.isFullScreen = !this.isFullScreen;
      if (this.isFullScreen) {
        if (document.body.requestFullscreen) {
          document.body.requestFullscreen();
        } else if (div.webkitRequestFullScreen) {
          document.body.webkitRequestFullScreen();
        } else if (div.mozRequestFullScreen) {
          document.body.mozRequestFullScreen();
        } else if (div.msRequestFullScreen) {
          document.body.msRequestFullScreen();
        }
      } else {
        document.exitFullscreen();
      }
    },
    toStoreCenter() {
      this.map.setZoom(this.initializedZooms);
      this.storeToCenter();
    },
    storeToCenter() {
      this.map.panTo(this.storeData.position);
      this.map.panBy(112, 0);
    },
    //将毫秒转化成时分秒
    formatTime(msTime) {
      let time = msTime;
      let day = Math.floor(time / 59 / 60 / 24);
      let hour = Math.floor(time / 59 / 60) % 24;
      let minute = Math.floor(time / 59) % 60;
      let second = Math.floor(time) % 59;
      return `${hour} h ${minute} mins`;
    },
    //关闭所有地图上的弹框
    closeAllFun() {
      this.showRightSidebar = false;
      this.selectedMarkers = [];
      let arr = this.map_task_list
      if (arr) {
        const batchUpdateTaskList = (batchSize) => {
          let index = 0;
          const updateBatch = () => {
            for (let i = 0; i < batchSize && index < arr.length; i++) {
              const item = arr[index];
              item.open = false;
              item.mean = 'normal'
              item.open_index = false
              item.mean = 'normal'
              item.click_color = "#ffffff";
              index++;
            }
            if (index < arr.length) {
              requestAnimationFrame(updateBatch);
            }
          };
          updateBatch();
        };
        batchUpdateTaskList(50); // 以每批 50 个项目的速度更新
      }
      this.map_draw_line_arr = [];
      this.map_driver_list.forEach(v=>{
        v.open = false
      })
    },

    //打开司机弹框
    openDriverInfoWindowTemplate(index) {
      this.closeAllFun();
      this.map_driver_list[index].open = true;
      setTimeout(() => {
        var infoWindowContent = document.getElementById("driver_info_box");
        this.driver_info_width = infoWindowContent?.offsetWidth / 2 + 20;
      }, 100);
      this.$forceUpdate();
    },
    //打开任务任务信息弹框
    openInfoWindowTemplate(index, task) {
      this.closeAllFunForTask(task);
      this.map_task_list[index].open = true;
      this.map_task_list[index].mean = "highlight";

      this.map_task_list.forEach((v) => {
        v.open_index = false;
      });

      setTimeout(() => {
        var infoWindowContent = document.getElementById("infoWindowContent");
        this.infoWindowWidth = infoWindowContent.offsetWidth / 2 + 20;
      });
      this.$forceUpdate();
      // console.log(this.map_task_list[index])
    },

    //模拟清除地图上的覆盖物  根据task类型
    closeAllFunForTask(task) {
      this.showRightSidebar = false;
      this.selectedMarkers = [];
      let arr = this.map_task_list

      if (arr) {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i]

          if(item.task_id === task.task_id){
              // console.log('-当前任务依旧显示不做处理--')
            }else{
              item.open = false;
              item.open_index = false
              item.click_color = "#ffffff";
            }
        }
      }
      this.map_draw_line_arr = [];
    },

    //打开司机弹框
    openDriverInfoHandle(data) {
      const index = this.map_driver_list.findIndex(
        (item) => item.worker_id == data.worker_id
      );
      if (data.show_map_driver) this.openDriverInfoWindowTemplate(index)
      else {
        const bounds = this.map.getBounds();
        let point = {
          lat: data.position.lat,
          lng: data.position.lng,
        };
        if (bounds && bounds.contains(point)) {
          if (index > -1) this.openDriverInfoWindowTemplate(index);
        } else {
          this.closeAllFun();
        }
      }
    },
    findMarkerHandle(e, data) {
      // console.log(e,data)
      const index = this.map_task_list.findIndex((item) => item.task_id === e);
      // console.log('-index--',index)
      if (index > -1){
        this.openInfoWindowTemplate(index, data);
      }
    },

    getChangeIcons(task) {
      return icon.getChangeIcon(task);
    },

    dragMap() {
      // this.closeAllFun()
      // this.startRollingTimer();
    },
    startRollingTimer() {
      if (this.rollingTimer !== null) {
        try {
          window.clearTimeout(this.rollingTimer);
        } catch (e) {
          /**/
        }
      }
      this.rollingTimer = setTimeout(() => {
        let nextIndex;
        if (this.currentDriverIndex < this.driversData?.drivers.length - 1) {
          nextIndex = this.currentDriverIndex + 1;
        } else {
          nextIndex = 0;
        }
        // this.chooseDriver(nextIndex, true);
      }, 30000);
    },
    // getTaskIcon(task) {
    //   //mean：normal(正常) dark（暗） highlight（高亮）
    //  icon.getChangeIcon(task)
    // },
    getIcon(status) {
      switch (status.is_transfer) {
        case 0:
          return this.icons.icon_free;
        case 1:
          return this.icons.icon_working;
      }
    },
    // drawLine(data) {
    //   //接收当前关联的司机 将对应的任务mean 修改成 高亮 将其他的修改成 dark
    //   let arr = [];
    //   data.tasks?.forEach((i) => {
    //     i.data.forEach((item, index) => {
    //       arr.push({
    //         lat: Number(item.latitude),
    //         lng: Number(item.longitude),
    //         task_id: item.task_id,
    //       });
    //     });
    //   });
    //   this.tasksData?.forEach((v) => {
    //     delete v.index;
    //     arr.forEach((arr_item, index) => {
    //       if (arr_item.task_id == v.task_id) {
    //         v.index = (index + 1).toString();
    //       }
    //     });
    //   });
    //   this.path = arr;
    // },
  },
  destroyed() {
    clearInterval(this.timer)
  },
};
